import {
  ChangeDetectorRef, Component, Input, ViewChild,
  SimpleChanges, OnChanges, ElementRef,
} from '@angular/core';
import * as _ from 'lodash';
import { polyfill } from 'smoothscroll-polyfill';

import { BaseModalComponent } from '../../modal/_base-modal.component';
import { SubscriptionService } from '../../subscription/subscription.service';
import { LoaderComponent } from '../../loader/loader.component';
import { DefaultModalComponent } from '../default-modal/default-modal.component';


@Component({
  moduleId: module.id,
  selector: 'modal-v2',
  templateUrl: 'modal-v2.component.html',
  styleUrls: ['modal-v2.component.scss'],
})
export class ModalV2Component extends BaseModalComponent implements OnChanges {
  @Input() headerColor: string = 'lightergrey';
  @Input() headerTitle: string;
  @Input() actionPanelTitle: string;
  @Input() showActionPanel: boolean = false;
  @Input() showLoader: boolean = false;

  @ViewChild(LoaderComponent, {static: false}) loader: LoaderComponent | void;
  @ViewChild('modalBody', {static: false}) modalBody: ElementRef | void;

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
    polyfill();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (_.has(changes, 'showLoader')) {
      if (changes.showLoader.currentValue) {
        if (this.loader instanceof LoaderComponent) {
          this.loader.show();
        }
      } else {
        if (this.loader instanceof LoaderComponent) {
          this.loader.hide();
        }
      }
      this.ref.markForCheck();
    }
  }

  public scrollTo(top: number) {
    if (this.modalBody) {
      this.modalBody.nativeElement.scrollTo({ top, behavior: 'smooth' });
    }
  }

}
